import React from "react";
import useChrModal from "../../../../../hooks/generic/Form/useChrModal";
import CustomizeCookiePreferences from "..";
import i18n from "../../../../../utils/ChrI18n";

const useCustomizeCookiePreferencesModal = (data, setIsVisible) => {

  const { ChrModal, modalOptions, modalControls } = useChrModal();

  const modalContent =
    modalOptions.show &&
    <ChrModal
      { ...modalOptions }
      header={i18n.t("feature.cookie_consent.header.customize_cookie_preferences")}
      extraModalOptions={{ className: "cookie-consent-new-ux" }}
    >
      <CustomizeCookiePreferences hideModal={modalControls.hideModal} setIsVisible={setIsVisible} data={data} />
    </ChrModal>;

  return {
    modalControls,
    modalContent
  };
};

export default useCustomizeCookiePreferencesModal;